import React from "react";
import { observer } from "mobx-react";

import { Button, Dialog, IconButton, Typography } from "@material-ui/core";

import "../../styles/PopUp.scss";

import TextRipleyComponent from "./TextRipleyComponent";
import * as ValidationUtils from "../../utils/ValidationUtils";
import { Close } from "@material-ui/icons";

const styles = {
  popupstyle: {
    width: "100%",
  },
  popupTitle: {
    width: "100%",
  },
  iconStyle: {
    alignSelf: "center",
    marginRight: "10px",
  },
  panelStyle: {
    marginTop: "15px",
  },
};

class SmsCodigoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valorCampos: ["", "", "", "", "", ""],
      isValid: false,
    };
    this.campos = [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()];
  }

  onAceptar = () => {
    const codigo = this.state.valorCampos[0] + this.state.valorCampos[1] + this.state.valorCampos[2] + this.state.valorCampos[3] + this.state.valorCampos[4] + this.state.valorCampos[5];
    if (this.props.onAceptar) {
      this.props.onAceptar(codigo);
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.clearData();
  };

  getTexto = () => {
    return <p id="txtModal">Ingrese el código que hemos enviado al número (+56) {this.props.telefono}. Si no te ha llegado el SMS espera unos minutos y no actualices el navegador.</p>;
  };

  clearData = () => {
    this.setState({
      valorCampos: ["", "", "", "", "", ""],
      isValid: false,
    });
  };

  onKeyDown = (event) => {
    if (event.keyCode === 8) {
      const index = parseInt(event.target.id);
      if (this.state.valorCampos[index] === "") {
        if (index > 0) {
          const prevIndex = index - 1;
          this.campos[prevIndex].current.focus();
          event.preventDefault();
        }
      }
    }
  };

  onTextChange = (evt) => {
    const index = parseInt(evt.target.id);
    const value = evt.target.value;
    if (ValidationUtils.isNumberOrEmpty(value) && value.length <= 1) {
      if (ValidationUtils.isNumber(value)) {
        if (evt.target.id < 5) {
          const nextIndex = parseInt(index) + 1;
          this.campos[nextIndex].current.focus();
        }
      }

      this.setState((prevState)=> {
          const valorCampos = prevState.valorCampos;
          valorCampos[index] = value;
          return { valorCampos };
        },
        this.validate
      );
    }
  };

  validate = () => {
    const valid = this.state.valorCampos.find((item) => {
      return !item;
    });
    if (valid) {
      this.setState({ isValid: false });
    } else {
      this.setState({ isValid: true });
    }
  };

  render() {
    const texto = this.getTexto();
    return (
      <Dialog id="modal" modal="true" open={this.props.open} style={styles.popupstyle}>
        <div className="Panel" style={styles.panelStyle}>
          <div className="titlePopup">
            <div id="txtTituloModal" style={styles.popupTitle}>
              Autorización SMS
              <IconButton onClick={this.onClose}>
                <Close />
              </IconButton>
            </div>
          </div>
          <div className="boxMensaje">
            <div className="mensaje">
              {texto}
              <div className="ingrsecodigo">
                <TextRipleyComponent type="tel" autoFocus={true} id="0" onChange={this.onTextChange} key={1} value={this.state.valorCampos[0]} ref={this.campos[0]} onKeyDown={this.onKeyDown} />
                <TextRipleyComponent type="tel" id="1" onChange={this.onTextChange} key={2} value={this.state.valorCampos[1]} ref={this.campos[1]} onKeyDown={this.onKeyDown} />
                <TextRipleyComponent type="tel" id="2" onChange={this.onTextChange} key={3} value={this.state.valorCampos[2]} ref={this.campos[2]} onKeyDown={this.onKeyDown} />
                <TextRipleyComponent type="tel" id="3" onChange={this.onTextChange} key={4} value={this.state.valorCampos[3]} ref={this.campos[3]} onKeyDown={this.onKeyDown} />
                <TextRipleyComponent type="tel" id="4" onChange={this.onTextChange} key={5} value={this.state.valorCampos[4]} ref={this.campos[4]} onKeyDown={this.onKeyDown} />
                <TextRipleyComponent type="tel" id="5" onChange={this.onTextChange} key={6} value={this.state.valorCampos[5]} ref={this.campos[5]} onKeyDown={this.onKeyDown} />
              </div>
              <Typography className="menajeSmS">Si acabas de hacer una solicitud, ingresa el mismo SMS que te enviamos hace un momento</Typography>
            </div>
            <div className="boxButton">
              <Button id="btnPopUp" variant="contained" color="primary" onClick={this.onAceptar} className="btn-moradoModal" disabled={!this.state.isValid} fullWidth={true}>
                aceptar
              </Button>
            </div>
          </div>
          <div className="franjaColores">
            <div className="rojo" />
            <div className="amarillo" />
            <div className="morado" />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default observer(SmsCodigoComponent);
